import React from "react";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import { useTranslation } from "react-i18next";
import { useGatedOpen } from "../hooks/usePollingGate";
import { L_FDS } from "./closeOutSchemas";

const FinalDraftSurveyConfirmDialog: React.FC<{
  open: boolean;
  total: string;
  isSubmitting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, total, isSubmitting = false, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  useGatedOpen(open);
  return (
    <GenericDialog
      open={open}
      testId="final-draft-survey-confirm-dialog"
      title={t(`${L_FDS}.confirm.title`)}
      content={t(`${L_FDS}.confirm.text`, { total })}
      cancelButtonText={t(`${L_FDS}.confirm.cancel`)}
      confirmButtonText={t(`${L_FDS}.confirm.confirm`)}
      handleCloseDialog={onCancel}
      confirmAction={onConfirm}
      isSubmitting={isSubmitting}
    />
  );
};

export default FinalDraftSurveyConfirmDialog;
